import React, { useState } from "react";
import EditIcon from '@mui/icons-material/Edit';
import { styled } from '@mui/material/styles';
import { useTheme } from "@emotion/react";
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import { ActionContainer, ColumnContent, ComponentWrapper, HeaderText, HorizontalContainer, MainContent, VerticalContainer } from "../../../../../StyledComponents";

const Mortgages = ({ mortgageData, handleOpenEditModal }) => {
  const theme = useTheme()

  const [expanded, setExpanded] = useState('')

  const handleChange = (panel) => (event, newExpanded) => {
    setExpanded(newExpanded ? panel : false)
  }

  return (
    <ComponentWrapper>
      <Accordion expanded={expanded === 'panel1'} onChange={handleChange('panel1')} style={{border: 'none', borderBottom: `0.1rem solid ${theme.palette.common.grayText}`}}>
        <AccordionSummary aria-controls="panel1d-content" id="panel1d-header" style={{background: `${theme.palette.common.grayBorder}`}}>
          <HeaderText className="sub">Mortgages</HeaderText>
        </AccordionSummary>
        <AccordionDetails style={{borderTop: `0.1rem solid ${theme.palette.common.grayText}`}}>
          <HorizontalContainer className='grid notificationSchedules fitContent'>
            <VerticalContainer className="fitContent">
              <ColumnContent className="bottomBorder">
                index
              </ColumnContent>
              {mortgageData.map((data, index) => (
                <ColumnContent key={index} style={{gridColumn: '1'}}>
                  <MainContent>{index + 1}</MainContent>
                </ColumnContent>
              ))}
            </VerticalContainer>
            <VerticalContainer className="fitContent">
              <ColumnContent className="bottomBorder">
                Mortgage ID
              </ColumnContent>
              {mortgageData.map((data) => (
                <ColumnContent key={data._id}  style={{gridColumn: '2'}}>
                  <MainContent>{data._id}</MainContent>
                </ColumnContent>
              ))}
            </VerticalContainer>
            <VerticalContainer className="fitContent">
              <ColumnContent className="bottomBorder">
                Owner One
              </ColumnContent>
              {mortgageData.map((data) => (
                <ColumnContent key={data._id}  style={{gridColumn: '3'}}>
                  <MainContent>{data.owner1}</MainContent>
                  <ActionContainer className="edit" onClick={() => handleOpenEditModal(data._id, 'owner1', data.owner1)}>
                    <EditIcon />
                  </ActionContainer>
                </ColumnContent>
              ))}
            </VerticalContainer>
            <VerticalContainer className="fitContent">
              <ColumnContent className="bottomBorder">
                Owner Two
              </ColumnContent>
              {mortgageData.map((data) => (
                <ColumnContent key={data._id}  style={{gridColumn: '3'}}>
                  <MainContent>{data.owner2}</MainContent>
                  <ActionContainer className="edit" onClick={() => handleOpenEditModal(data._id, 'owner2', data.owner2)}>
                    <EditIcon />
                  </ActionContainer>
                </ColumnContent>
              ))}
            </VerticalContainer>
          </HorizontalContainer>
          <HorizontalContainer className='grid notificationSchedules fitContent'>
            <VerticalContainer className="fitContent">
              <ColumnContent className="bottomBorder">
                Number of Units
              </ColumnContent>
              {mortgageData.map((data) => (
                <ColumnContent key={data._id}  style={{gridColumn: '2'}}>
                  <MainContent>{data.recordDetails.building.NumberOfUnitsTotal.currentValue}</MainContent>
                  <ActionContainer className="edit" onClick={() => handleOpenEditModal(data._id, 'numberOfUnits', data.recordDetails.building.NumberOfUnitsTotal.currentValue)}>
                    <EditIcon />
                  </ActionContainer>
                </ColumnContent>
              ))}
            </VerticalContainer>
          </HorizontalContainer>
        </AccordionDetails>
      </Accordion>
    </ComponentWrapper>
  )
}

const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  border: `0.1rem solid ${theme.palette.common.grayBorder}`,
  width: '100%',
  '&:not(:last-child)': {
    borderBottom: 0,
  },
  '&:before': {
    display: 'none',
  },
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
    {...props}
  />
))(({ theme }) => ({
  backgroundColor:
    theme.palette.mode === 'dark'
      ? 'rgba(255, 255, 255, .05)'
      : 'none',
  flexDirection: 'row-reverse',
  minHeight: '3rem',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)',
  },
  '& .MuiAccordionSummary-content': {
    margin: '0',
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  padding: '1rem',
  borderTop: '1px solid rgba(0, 0, 0, .125)',
}));

export default Mortgages